var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 512"}},[_c('path',{staticClass:"fill-color",attrs:{"fill":"currentColor","d":"M40 8v496c0 4.416-3.584 8-8 8s-8-3.584-8-8V8C24 3.582 27.58 0 32 0S40 3.582 40 8z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }